import { useQuery } from "@tanstack/react-query";
import type { StrandLossByShift } from "../../models/StrandLossByShift";
import { getStrandLossesByShift } from "../../repositories/StrandLossesManagerRepository";

export const useStrandLossesByShiftQuery = (
  shiftId: number,
  includeMicroDelays: boolean,
  onError?: (error: Error) => void,
) =>
  useQuery({
    queryKey: ["strand-losses-by-shift", shiftId, includeMicroDelays],
    queryFn: async ({ signal }): Promise<StrandLossByShift[]> => {
      const response = await getStrandLossesByShift(
        shiftId,
        includeMicroDelays,
        signal,
      );
      if (!response.ok) {
        throw new Error(response.message ?? "Failed to fetch Strand Losses");
      }
      return response.data;
    },
    enabled: shiftId > 0,
    onError,
  });
